// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3PSYB","detailsBorder":"styles_detailsBorder__1fv40"};